export default "__VITE_ASSET__C9xBhONZ__"